import { useDownloadCompanyBackup } from "http-hooks/companyAdmin/useCompanyAdmin";
import useCompanyAuth from "hooks/useCompanyAuth";
import { ArrowDownTrayIcon } from "@heroicons/react/24/outline";

export default function CompanyBackup() {
  const { mutateAsync, isPending } = useDownloadCompanyBackup();
  const { companyId } = useCompanyAuth();

  const handleDownload = async () => {
    try {
      await mutateAsync();
    } catch (error) {
      console.error("Backup download failed:", error);
    }
  };

  return (
    <div className="px-4 sm:px-6 lg:px-8">
      <div className="md:flex md:items-center md:justify-between mb-6">
        <div className="min-w-0 flex-1">
          <h2 className="text-2xl font-bold leading-7 text-gray-900 sm:truncate sm:text-3xl sm:tracking-tight">
            Database Backup
          </h2>
          <p className="mt-1 text-sm text-gray-500">
            Download a complete backup of your company database
          </p>
        </div>
      </div>

      <div className="bg-white shadow rounded-lg max-w-2xl">
        <div className="px-6 py-4 border-b border-gray-200">
          <h3 className="text-lg font-semibold text-gray-900">
            Download Backup
          </h3>
        </div>
        <div className="px-6 py-6">
          <div className="rounded-md bg-blue-50 border border-blue-200 p-4 mb-6">
            <div className="flex">
              <svg
                className="h-5 w-5 text-blue-600 mr-2 flex-shrink-0 mt-0.5"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                />
              </svg>
              <div>
                <p className="text-sm text-blue-800 font-medium">
                  About Database Backup
                </p>
                <ul className="text-xs text-blue-700 mt-2 space-y-1 list-disc list-inside">
                  <li>
                    Downloads a complete SQL dump of your company database (agentio_{companyId})
                  </li>
                  <li>
                    Includes all tables, data, and structure
                  </li>
                  <li>
                    The file can be used to restore your data if needed
                  </li>
                  <li>
                    Download time depends on your database size
                  </li>
                </ul>
              </div>
            </div>
          </div>

          <div className="flex items-center gap-4">
            <button
              type="button"
              onClick={handleDownload}
              disabled={isPending}
              className="inline-flex items-center gap-x-2 rounded-md bg-indigo-600 px-5 py-3 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600 disabled:opacity-50 disabled:cursor-not-allowed"
            >
              <ArrowDownTrayIcon className="h-5 w-5" aria-hidden="true" />
              {isPending ? "Downloading..." : "Download Backup (.sql)"}
            </button>

            {isPending && (
              <p className="text-sm text-gray-500">
                Please wait, generating backup...
              </p>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
